"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OfferTitle;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function OfferTitle(_ref) {
  var index = _ref.index,
    title = _ref.title;
  var breakPoint = (0, _r10SourceLibrary.useBreakpoints)();
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 4
    }
  }, title && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    weight: 3,
    justify: breakPoint.sm ? 'center' : 'left',
    text: title,
    "data-testid": true,
    dataAttributes: {
      'data-testid': "offer-card-title-".concat(index)
    }
  }));
}
OfferTitle.propTypes = {
  index: _propTypes.default.number,
  title: _propTypes.default.string
};